<template>
  <div class="header shadow-sm">
    <div class="header__inner">
      <router-link :to="{ name: 'DashboardHome'       }"><img class="header__logo pointer" src="../assets/SmartSalesLogo2.png"></router-link>

      <div class="header__right" v-if="currentUser && currentUser.AppUserId">
        <div class="header__right__profile--info">
          <div>{{currentUser.FirstName}} {{currentUser.LastName}}</div>
          <div>{{ currentUserRole }}</div>
        </div>
        <div class="dropdown message-icon-container" v-if="notifications">
          <i class="fa fa-envelope pointer" :class="unreadNotifications ? 'unread' : 'read'" data-toggle="dropdown"></i>
          <div class="dropdown-menu mailbox-wrapper">
            <div class="delete-btn-wrapper">
              <div class="btn btn-primary delete-btn" @click="openDeleteModal()">DELETE SELECTED</div>
              <div @click.stop="selectAllButtonClicked" class="select-all">
                <i v-if="!allNotificationsAreSelected" class="far fa-square"></i>
                <i v-else class="fa fa-check-square"></i>
              </div>
            </div>
            <div class="dropdown-wrapper mailbox">
              <div class="no-notifications-message" v-if="!notificationsExcludingSoftDeleted.length" >No Notifications</div>

              <div class="row m-0 message-row pointer" v-for="notification in notificationsExcludingSoftDeleted" :key="notification.id" :class="notification.IsRead ? 'read' : 'unread'">
                <div class="col m-0 message-col"   @click.stop="openMail(notification)" >
                  <div class="row mx-2 from-row">From: {{notification.FromFullName}}</div>
                  <div class="row mx-2 subject-row">Subject: {{notification.Subject}}</div>
                </div>
                <!-- <div class="col-2 trash-col" @click.stop="openDeleteModal(notification)">
                  <i class="fa fa-trash" ></i>
                </div> -->
                <div class="col-2 trash-col" @click.stop="selectingNotification(notification)">
                  <i v-if="notificationIsSelected(notification)" class="fa fa-check-square"></i>
                  <i v-else class="far fa-square"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <i class="fa fa-cog pointer" @click="$router.push({ name: 'Settings' })"></i>
        <i class="fa fa-sign-out-alt pointer" @click="logout"></i>
      </div>

      <div v-if="!currentUser || !currentUser.AppUserId">
        <!-- <router-link :to="{ name: 'Login'  }" class="m-2">Login</router-link>
        <router-link :to="{ name: 'Signup' }" class="m-2">Signup</router-link> -->
      </div>

    </div>
    <Modal ref="mailModal">
      <div v-if="notification" class="card modal-wrapper p-4">
        <BasicTextInput label="From" :value="notification.FromFullName" :disabled="true"/>
        <BasicTextInput label="Subject" :value="notification.Subject" :disabled="true"/>
        <div class="mt-3" >
          <textarea class="form-control"
            :rows="10"
            :columns="5"
            :value="notification.Message"
            :disabled="true">
          </textarea>
        </div>
        <div class="btn btn-primary order-nav-btn pointer" v-if="currentNotificationType === 'Transfer'" @click="goToOrder">Go To Order</div>
      </div>
    </Modal>
    <Modal ref="deleteModal">
      <div v-if="selectedNotifications.length" class="card modal-wrapper p-4">
        <div class="delete-modal-text">
          Are you sure you would like to delete these notifications?
        </div>
        <div class="btn btn-primary order-nav-btn pointer" @click.stop="deleteNotifications">Delete</div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { userRoleEnum, notificationTypeEnum, getKeyByValue } from "../modules/helpers";
  import { NotificationsService }from '../services'

  export default {
    data(){
      return {
        notification: null,
        selectedNotifications: [],
        version: new Date().getTime(), // Add a timestamp to force cache invalidation
      }
    },
    mounted() {
      // Ensure user data is loaded only if we have a token
      if (this.$store.state.token && (!this.currentUser || !this.currentUser.AppUserId)) {
        this.$store.dispatch('GET_CURRENT_USER').catch(() => {
          // Silently handle authentication failures
        });
      }
      // Ensure notifications are loaded only if we have a token
      if (this.$store.state.token && !this.notifications) {
        this.$store.dispatch('GET_USER_NOTIFICATIONS').catch(() => {
          // Silently handle authentication failures
        });
      }
    },
    methods: {
      selectAllButtonClicked(){
        if(!Array.isArray(this.notifications)) {
          return;
        }

        if(this.selectedNotifications.length === this.notifications.length){
          this.selectedNotifications = [];
        } else {
          this.selectedNotifications = []
          this.notifications.forEach(notification => {
            this.selectedNotifications.push(notification.Id)
          })
        }
      },
      selectingNotification(notification){
        let index = this.selectedNotifications.indexOf(notification.Id);
        if(index < 0){
          this.selectedNotifications.push(notification.Id);
        } else {
          this.selectedNotifications.splice(index, 1)
        }
      },
      notificationIsSelected(notification){
        return this.selectedNotifications.indexOf(notification.Id) >= 0;
      },
      logout(){
        let answer = true;
        if(this.$route.name === 'CustomerOrder' || this.$route.name === 'CustomerOrderEdit'){
          answer = window.confirm('Are you sure you would like to logout? Any unsaved changes will be lost.');
        }
        if (answer) {
          this.$store.dispatch('AUTH_LOGOUT');
        }
      },
      goToOrder(){
        if(this.currentNotificationType === 'Transfer'){
          this.$router.replace({ name: 'CustomerOrderEdit', params: { id: this.notification.OrderId, cid: this.notification.CustomerId } } );
          this.$router.go();
          this.toggleMail()
        }
      },
      setMailAsRead(){
        const readNotification = {
          ...this.notification,
          IsRead: true
        }
        NotificationsService.update(readNotification)
          .then(() => {
            this.notification = readNotification;
            this.$store.dispatch('GET_USER_NOTIFICATIONS');
          })
          .catch(error => {
            console.log('Error updating notification:', error)
          })
      },
      setMailAsDeleted(){
        // const deletedNotification = {
        //   ...this.notification,
        //   IsDeleted: true
        // }
        NotificationsService.delete(this.selectedNotifications)
          .then(() => {
            this.toggleDeleteModal();
            this.selectNotification = [];
            this.notification = null;
            this.$store.dispatch('GET_USER_NOTIFICATIONS');
            this.$store.dispatch('ADD_NOTIFICATION', {text: 'Notifications have been deleted', type: 'success'})
          })
          .catch(error => {
            console.log('Error deleting notifications:', error)
            this.$store.dispatch('ADD_NOTIFICATION', {text: 'Unable to delete notifications at this time', type: 'error'})
            this.toggleDeleteModal();
          })
      },
      openMail(notification){
        this.notification = notification;
        this.setMailAsRead()
        this.toggleMail()
      },
      // openDeleteModal(notification){
      //   this.notification = notification;
      //   this.toggleDeleteModal();
      // },
      openDeleteModal(){
        this.toggleDeleteModal();
      },
      toggleMail(){
        this.$refs.mailModal.toggle();
      },
      toggleDeleteModal(){
        this.$refs.deleteModal.toggle();
      },
      deleteNotification(){
        this.setMailAsDeleted()
      },
      deleteNotifications(){
        this.setMailAsDeleted()
      }
    },
    computed: {
      ...mapState(['currentUser', 'notifications']),
      allNotificationsAreSelected(){
        return Array.isArray(this.notifications)
          ? this.notifications.length === this.selectedNotifications.length
          : false;
      },
      currentUserRole(){
        return this.currentUser && this.currentUser.UserRoleId ? getKeyByValue(userRoleEnum, this.currentUser.UserRoleId) : '';
      },
      currentNotificationType(){
        return this.notification && this.notification.NotificationTypeId ?
          getKeyByValue(notificationTypeEnum, this.notification.NotificationTypeId) : '';
      },
      notificationsExcludingSoftDeleted(){
				//console.log('notifications', this.notifications)
        return Array.isArray(this.notifications)
          ? this.notifications.filter(notification => !notification.IsDeleted)
          : []
      },
      unreadNotifications(){
        const unreadNotification = this.notificationsExcludingSoftDeleted.find(notification => !notification.IsRead);
        return unreadNotification ? true : false;
      }
    }
}
</script>

<style lang="scss" scoped>
  .header{
    height: 50px;
    display: flex;
    align-items: center;
    width: 100%;
    background: $ss-blue-light;
    padding-left: 20px;
    padding-right: 20px;
    position: relative; /* Ensure proper stacking context in Chrome */
    z-index: 1000; /* Ensure header is above other elements */
    &__inner {
      color: $primary;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-width: 100%;
      width: 100%; /* Ensure full width in Chrome */
      position: relative; /* Create stacking context */
    }
    &__logo {
      height: 24px;
    }
    &__right{
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 25px;
        margin-left: 8px;
        margin-right: 8px;
      }
      &__profile--info {
        font-size: .8em;
        display: flex;
        align-items: flex-end;
        padding-right: 25px;
        flex-direction: column;
      }
    }
    .select-all {
      color: $primary;
      align-self: center;
      margin-bottom: 10px;
    }
    .modal-wrapper {
      width: 400px;
    }
  }
  .message-icon-container{
    height: 25px;
    .read{
      color: $primary;
    }
    .unread{
      color: $red;
    }
  }
  .mailbox-wrapper{
    min-width: 400px;
    min-height: 400px;
    max-height: 400px;
    overflow: hidden;
    background-color: $ss-grey2;
    border-radius: 5px;
    border: solid 1px $primary;
    left: -150px !important;
    padding: 10px;
    .delete-btn-wrapper{
      display: flex;
      justify-content: flex-end;
      border-bottom: solid 1px $primary;
      .delete-btn {
        margin-bottom: 10px;
        align-self: flex-end;
      }
    }
  }
  .mailbox{
    overflow: scroll;
    max-height: 350px;
    background-color: $ss-grey2;

    padding: 10px;

      .no-notifications-message {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 400px;
        min-height: 400px;
        max-height: 400px;
      }
      .header-row {
        border-bottom: solid 1px $primary;
        color: $primary;
        // .from-header {
        //   color: $primary;

        // }
        // .subject-header{
        //   color: $primary;
        // }
      }

      .message-row {
        border-bottom: solid 1px $primary;
        &.read{
          color: $primary;
        }
        &.unread{
          color: $red;
        }
        :hover{
            background-color: $ss-grey4;
            color: $white;
          }
        .message-col {
          padding: 5px 0px;


        }
        .trash-col {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        // .from-column{

        // }
        // .subject-column{

        // }


    }
  }
  .order-nav-btn{
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .delete-modal-text{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 20px;
    margin: 10px;
  }

</style>
